// extracted by mini-css-extract-plugin
export default {"view":"main-view_view__e72rH"};